import { setCookie } from "./cookie";
import { setStorageItem } from "./localStorage";
import {
  AUTH_TOKEN_COOKIE_KEY,
  APP_CLIENT_STORAGE_KEY,
  APP_UID_STORAGE_KEY,
  LOGIN_STORAGE_KEY,
  USER_STORAGE_KEY,
} from "constants";

/**
 * Updates authentication cookies and localStorage after successful login.
 * This mirrors the Polaris updateHeaders function.
 * 
 * @param {Object} response - The login response from the API
 * @param {Object} response.data - Response data containing user info
 * @param {Object} response.data.user - User object
 * @param {Object} authHeaders - Auth headers from the response
 * @param {string} authHeaders["access-token"] - The access token
 * @param {string} authHeaders.client - The client identifier
 * @param {string} authHeaders.uid - The user ID (email)
 */
export const updateAuthCredentials = (response, authHeaders) => {
  // Store auth headers in cookies (same keys as Polaris: Auth_Token, Client, UID)
  if (authHeaders?.["access-token"]) {
    setCookie(AUTH_TOKEN_COOKIE_KEY, authHeaders["access-token"]);
  }
  if (authHeaders?.client) {
    setCookie(APP_CLIENT_STORAGE_KEY, authHeaders.client);
  }
  if (authHeaders?.uid) {
    setCookie(APP_UID_STORAGE_KEY, authHeaders.uid);
  }

  // Store user info in localStorage
  if (response?.data?.user) {
    setStorageItem(USER_STORAGE_KEY, response.data.user);
  }

  // Mark as logged in
  setStorageItem(LOGIN_STORAGE_KEY, "yes");
};

/**
 * Gets the error message from a login error response
 * @param {Object} error - The error object from RTK Query
 * @returns {string} - Human readable error message
 */
export const getLoginErrorMessage = (error) => {
  if (!error) return "An unknown error occurred";
  
  // Handle RTK Query error structure
  if (error.data?.errors) {
    if (Array.isArray(error.data.errors)) {
      return error.data.errors.join(", ");
    }
    return error.data.errors;
  }
  
  if (error.message) {
    return error.message;
  }
  
  if (error.status === 401) {
    return "Invalid email or password";
  }
  
  if (error.status === 403) {
    return "Access denied. Please contact your administrator.";
  }
  
  return "Login failed. Please try again.";
};

